import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { routes } from './routes'
import NoMatch from './pages/NoMatch'
import Layout from '@/components/layouts/Layout'
import { ScrollProvider } from '@/components/layouts/ScrollContext'

import './globals.css'
import './index.css'

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              {routes.map((route) => (
                <Route path={route.path} element={<route.component />} key={route.name} />
              ))}
              <Route path="*" element={<NoMatch />} />
            </Route>
          </Routes>
        </ScrollProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default App
